"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    clientTitle: {
        en: "Client Sync",
        es: "Sincronizar",
    },
    successCopy: {
        en: " was copied to clipboard.",
        es: " se copió al porta papel",
    },
    badCopy: {
        en: "Something went wrong, manualy copy ",
        es: "Algo salió mal, copie manualmente",
    },
    saving: {
        en: "Saving client please wait...",
        es: "guardando client, porfavor espere...",
    },
    success: {
        en: "Saved!",
        es: "Guardado!",
    },
    error: {
        en: "Error!",
        es: "Error!",
    },
    wait: {
        en: "Waiting for Response don't close this window or the code will change...",
        es: "Esperando respuesta, no cierre la ventana o el codigo cambiara...",
    },
};
exports.default = translations;
